export const ConfigBatchReadResponse = [
  // {
  //   httpStatus: "OK",
  //   property: {
  //     key: "BANNER_IMAGE_DASHBOARD",
  //     value: "https://via.placeholder.com/1200x240/007bff/ffffff?text=Dashboard+Banner",
  //     type: "STRING",
  //   },
  // },
  // {
  //   httpStatus: "OK",
  //   property: {
  //     key: "BANNER_URL_DASHBOARD",
  //     value: "https://example.com/dashboard-promotion",
  //     type: "STRING",
  //   },
  // },
  {
    httpStatus: "OK",
    property: {
      key: "PAYMENTS_ONLINE_ALLOWED",
      value: "true",
      type: "STRING",
    },
  },
  {
    httpStatus: "OK",
    property: {
      key: "PAYMENTS_PNM_INTEGRATION_ALLOWED",
      value: "false",
      type: "STRING",
    },
  },
  {
    httpStatus: "OK",
    property: {
      key: "AUTO_PAYMENTS_ONLINE_ALLOW_AUTO_DEBIT",
      value: "true",
      type: "STRING",
    },
  },
  {
    httpStatus: "OK",
    property: {
      key: "NEW_PAYMENT_PAGE_DESCRIPTION",
      value: "Here is where you will make a new payment. Good luck!",
      type: "STRING",
    },
  },
  {
    httpStatus: "OK",
    property: {
      key: "NEW_PAYMENT_PAGE_FOOTER_NOTE",
      value:
        "Note. You will be contacted by some cool unicorn whenever the payment has been successfully posted. Keep an eye out for it",
      type: "STRING",
    },
  },
  {
    httpStatus: "OK",
    property: {
      key: "PAYMENTS_ONLINE_FEE",
      value: "true",
      type: "STRING",
    },
  },
  {
    httpStatus: "OK",
    property: {
      key: "PAYMENTS_ONLINE_FEE_OPTION_3",
      value: "120;240;360",
      type: "STRING",
    },
  },
  {
    httpStatus: "OK",
    property: {
      key: "PAYMENTS_ONLINE_FEE_OPTION",
      value: "2",
      type: "STRING",
    },
  },
  {
    httpStatus: "OK",
    property: {
      key: "PAYMENTS_ONLINE_FEE_OPTION_4",
      value: "2-15=120;16-24=240;25-31=360",
      type: "STRING",
    },
  },
  {
    httpStatus: "OK",
    property: {
      key: "PAYMENTS_ONLINE_STATE_TRANSACTION_MAX",
      value: "CA=2500;TX=1250",
      type: "STRING",
    },
  },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
  { httpStatus: "NOT_FOUND", property: null },
];

export const GetUserByEmailResponse = [
  {
    id: "1234",
    givenName: "Giovanni",
    familyName: "Giorgio",
    role: "Borrower",
  },
];

export const GetUserAttributes = [{}];